import {Injectable} from '@angular/core';
import {ApiService} from '@shared/service';
import {Observable} from 'rxjs';
import {ApiResponse, ApiUriEnum} from '@shared/model';

@Injectable({
  providedIn: 'root'
})
export class ImportService extends ApiService {

  public importFile(entity: String, file: File): Observable<ApiResponse> {
    return this.sendFile(entity + ApiUriEnum.IMPORT_FILE, file);
  }
}
